import React, { useState, useEffect } from 'react';
import { Card, useAPI } from 'components/lib';
import { Table } from 'components/lib';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LogsNav } from './nav';


export function Monitors(props){

  const [recordList, setRecordList] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [, setDataTypeList] = useState([]);

  var records = useAPI('/api/appData/recordsToClean')
  var dataTypes = useAPI('/api/appData/dataTypes/')

  const updateRecordList = (records) => {
    console.log(JSON.stringify(records))
    if(!records) {
      return;
    }
    if(records.length) {
      console.log('records.data.length - ' + records.length)

      let recList = [];

      records.map((item) => {
        let id = item.id;
        //let data = item.data();
        recList.push({
          id: id,
          checked: false,
          type: item.record_type,
          name: item.name,
          Last_Updated: item.last_updated_at,
          monitor: item.rule_name,
          // issue: item.short_description,
          status: item.status,
          //recDetails: data.recDetails
        });
        return item; // Added return statement for array callback
      });

      setRecordList(recList);

    }
    else {
      setRecordList([]);
    }
  }

  useEffect(() => {
    updateRecordList(records.data)

  }, [records.data]);

  const updateCheckList = (rules) => {
    console.log('records?.rules - ' + JSON.stringify(rules))
    if(rules?.length) {
      console.log('records.data.length - ' + rules.length)

      let recList = [];

      rules.map((item) => {
        let id = item.id;
        //let data = item.data();
        recList.push({
          id: id,
          monitor: item.display_name,
        });
        return item; // Added return statement for array callback
      });

      setCheckList(recList);

    }
    else {
      setCheckList([]);
    }
  }

  useEffect(() => {
    updateCheckList(records?.data?.rules)

  }, [records.data?.rules]);
  
  useEffect(() => {
    if(dataTypes?.data?.length) {
      
      let recList = [];

      dataTypes.data.map((item) => {
        //let data = item.data();
        recList.push({
          value: item.name,
          label: item.name
        });
        return item; // Added return statement for array callback
      });

      setDataTypeList(recList);

    }

  }, [dataTypes.data]);

  const setActiveRecord = (rec, index) => {
    window.location = 'details/'+rec.id;
  };
  
  // const selectDataType = (val) => {
  //   setCurrentDataType(val)
    
  // }

  return (
    <>
    <LogsNav />

    
      
<>

      <Card>
        <div style={{display: 'flex', paddingBottom: 20}}>
          {/* <div style={{marginTop: '16px', paddingRight: '10px'}}>Filter:</div> */}
          <LocalizationProvider dateAdapter={AdapterMoment}>
            {/* <div style={{zIndex:1000}}>
            <Select
                placeholder="Data Types"
                onChange={(item) => {selectDataType(item.value)}}
                options={dataTypeList}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  control: (base) => ({...base, height: 53, minHeight: 53, marginRight: 20, marginLeft: 20 })
                }}
            />
            </div> */}
        

          {/* <Button
            text='Find'
            action={ findRecs }
            params={{ id: 'btnFind' }}
          /> */}

         
        </LocalizationProvider>
        </div>

        
      
      <Table
        search
        data={ recordList }
        checkItemList = {checkList}
        checkItems="monitor"
        loading={ recordList?.length === 0 }
        hide={'id,checked'}
        hyperlink={[{
          col: 'name',
          //url: '/app/DataHistory',
          //callback: loadCompany
        }]}
        badge={{ col: 'status', color: 'blue', condition: [

          { value: 'warning', color: 'yellow' },
          { value: 'error', color: 'red' }
        
        ]}}
        actions={{ 
          hyperlink: setActiveRecord,
          edit: setActiveRecord, 
          // selectRecord: selectRecord,
          //view: setActiveRecord, //'/dashboard' // will load this url + /rowID  
           
        }}
      >
      </Table>
      </Card>
      </>
    
    </>
  );
}
